/**
 * Sort branches with "master" pinned to the top, then alphabetically.
 * Does not mutate the input. Tolerates an undefined list (returns []).
 *
 * Master is identified by name (the branch model has no explicit flag), using
 * locale-independent `toLowerCase` so the check is culture-invariant.
 */
export function sortBranchesMasterFirst<T extends { name?: string }>(branches: readonly T[] | undefined | null): T[] {
  if (!branches) return [];
  return [...branches].sort((a, b) => {
    const aMaster = a.name?.toLowerCase() === "master";
    const bMaster = b.name?.toLowerCase() === "master";
    if (aMaster && !bMaster) return -1;
    if (bMaster && !aMaster) return 1;
    return (a.name ?? "").localeCompare(b.name ?? "");
  });
}
